import { Component, input } from '@angular/core';

@Component({
  selector: 'ntt-detail-row',
  templateUrl: './detail-row.html',
  styleUrl: './detail-row.scss',
})
export class DetailRow {
  readonly label = input.required<string>();
}
